import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Grow from '@material-ui/core/Grow';
import modalStyle from '../style'
import {getTranslation} from "../../../helpers/get-translation";
import {allHints} from "../../../helpers/cloud-function/hint-types";
import Hint from "./hint"

const styles = theme => (Object.assign({}, modalStyle, {
	modalBody: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		"max-height": "80%",
		width: "400px",
		margin: "0 20px",
		overflowY: "auto",
		overflowX: "hidden",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
	},
	hintsButton: {
		backgroundColor: "#353535",
		color: "white",
		"margin": "15px auto 20px",
		"width": "150px",
		"font-size": "24px",
		"border-radius": "40px",
		"&:hover": {
			backgroundColor: "#000"
		}
	},
	hintCounterContainer:{
		display: "flex",
		justifyContent: "center",
	},
	hintCounterText:{
		fontSize: "30px",
		fontWeight: "bold",
		color: "black",
		marginRight: "10px"
	},
	lightBulb: {
		display: 'inline',
		width: "28px",
	},

	"@media (max-width: 400px)":{
		modal:{
			"min-width": "95%",
		},
		modalBody:{
			padding: "10px 14px",
			width: "initial",
		},
		hintsButton: {
			marginBottom: "15px",
			marginTop: "5px",
		},
		hintCounterText:{
			fontSize: "26px",
		}
	}
}));

// const lightBulbImage = getTranslation("image_app_bar_hints");

const HintsModal = props => {
	const { classes,
		removeModalWindow,
		purchaseHint,
		activeLogo,
		hintCount,
		hintPrice,
		updateActiveLogoWithHint,
		addToast } = props;

	function getHint(hintType, hint){
		const hintValue = activeLogo[hint.firestoreKey];
		// const borderColor = hintValue ? {borderColor: getRgbaColor(hint.color)} : {borderColor: hint.color}
		return (
			<Hint hintValue={hintValue}
			      hintType={hintType}
			      key={`key-${hintType}`}
			      hint={hint}
			      onHintClick={onHintClick}/>
			// <div
			// 	className={classes.hint}
			// 	key={`key-${hintType}`}
			// 	style={{borderColor: hint.color}}
			// 	onClick={() => onHintClick(hintType, !!hintValue)}>
			// 	<img src={hint.img} style={{opacity: imageOpacity}}/>
			// 	<span style={{color: hint.color}}>
			// 		{hintValue ? getHintContent(hintType, hintValue) : getTranslation(hint.text)}
			// 	</span>
			// </div>
		)
	}

	function onHintClick(type, isPurchased){
		if(isPurchased){
			return
		}

		if(hintCount >= hintPrice[type]){
			updateActiveLogoWithHint(allHints[type].firestoreKey, null);
			purchaseHint(type);
		} else {
			addToast('modal_hints_not_enough_to_purchase');
		}
	}

	return (

		<Modal
			className={[classes.modal].join(" ")}
			onClose={() => removeModalWindow()}
			open={true}
		>
			<Grow in={true}>
				<div>
					<img className={classes.closeButton} src={getTranslation("image_modal_close_button")} onClick={() => removeModalWindow()}/>
					<div className={`${classes.modalBody} ${classes.defaultBody}`}>
						<div className={classes.hintCounterContainer}>
							<span className={classes.hintCounterText}>{getTranslation("modal_hints_title")}</span>
							{/*<div >*/}
							{/*<span className={classes.number}>{hintCount}</span>*/}
							{/*<img*/}
							{/*className={classes.lightBulb}*/}
							{/*src={lightBulbImage}/>*/}
							{/*</div>*/}
						</div>
						{Object.keys(allHints).map( hintType => {
								return getHint(hintType, allHints[hintType])
							}
						)}
						{/*<Button*/}
						{/*id="extra-levels-button"*/}
						{/*variant="contained"*/}
						{/*color="secondary"*/}
						{/*className={classes.hintsButton}*/}
						{/*onClick={e => {*/}
						{/*removeModalWindow()*/}
						{/*}}*/}
						{/*>*/}
						{/*{getTranslation("modal_hints_close_button")}*/}
						{/*</Button>*/}
					</div>
				</div>
			</Grow>
		</Modal>
	)
}

HintsModal.propTypes = {
	hintCount: PropTypes.number.isRequired,

	hintPrice: PropTypes.object.isRequired,

	classes: PropTypes.shape({
	}).isRequired,

	removeModalWindow: PropTypes.func.isRequired,
	updateActiveLogoWithHint: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
}


export default withStyles(styles)(HintsModal);
